import { PlusOutlined } from "@ant-design/icons"
import { Button, Divider, Input, Space } from "antd"
import { t } from "i18next"
import { useEffect, useRef, useState } from "react"
import { SelectInput, notification } from ".."

function SelectInputWithCustomAdd({ mutationFunction, loading, options, payloadKey = "name", ...rest }) {
  const [name, setName] = useState("")

  const inputRef = useRef(null)
  const dropdownRef = useRef(null)

  const onNameChange = event => {
    setName(event.target.value)
  }

  useEffect(() => {
    scrollToBottom()
  }, [options])

  const handleAddOption = e => {
    e.preventDefault()
    mutationFunction({ [payloadKey]: name })
      .unwrap()
      .then(() => {})
      .catch(error => notification.error({ message: error.message }))
    setName("")
    setTimeout(() => {
      inputRef.current?.focus()
    }, 0)
  }
  const handleEnterPressed = e => {
    if (e.key === "Enter") {
      e.stopPropagation()
      handleAddOption(e)
    }
  }

  const scrollToBottom = () => {
    dropdownRef?.current?.scrollTo(options.length)
  }
  return (
    <SelectInput
      dropdownRender={menu => {
        let menuObj = { ...menu }
        menuObj.ref = dropdownRef
        return (
          <>
            {menuObj}
            <>
              <Divider style={{ marginBlock: "12px" }} />
              <Space className="pi-8 mbe-12">
                <Input
                  style={{ minWidth: "250px" }}
                  placeholder={t("Please enter option")}
                  ref={inputRef}
                  value={name}
                  onChange={onNameChange}
                  required
                  maxLength={35}
                  onKeyDown={handleEnterPressed}
                />
                <Button size="large" type="text" icon={<PlusOutlined />} onClick={handleAddOption} loading={loading}>
                  {t("Add option")}
                </Button>
              </Space>
            </>
          </>
        )
      }}
      options={options}
      {...rest}
    />
  )
}

export default SelectInputWithCustomAdd
